module.exports = __webpack_public_path__ + "img/Edit.41d5a6e8.svg";